import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData } from "../../../../serverRequest";
import LoadingSpinner from "../../../../components/Loadder";
import moment from 'moment';
import ProductAssignmentListTable from "../../../../components/Tables/ProductAssignmentListTable";
import { Link } from 'react-router-dom';

export default function ProductAssignmentList() {
    const [open, setOpen] = React.useState(true);
    const [totalProductsAssignment, setTotalProductsAssignment] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    
    const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    };
  
    const filterProductAssignmentData = (products_assignment_data) => {
      //console.log(tickets_data);
      let totalproductassignment = [];
      if(products_assignment_data){
        for (let i = 0; i < products_assignment_data.length; i++) {
            totalproductassignment.push(products_assignment_data[i])
        }
      }
     
      setTotalProductsAssignment(totalproductassignment);
      return ({ "total": totalproductassignment})
    }
    React.useEffect(() => {
      async function fetchData() {
        let resData = await getData('/api/inventory/assignment/')
        let product_assignment_data = resData['data']['product_assignment_data']
        console.log(product_assignment_data);
        let productData = await filterProductAssignmentData(product_assignment_data)
  
       
        setLoading(false);
      }
      fetchData();
  
  
    }, [])
    return (
        <>

            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    <div className="rounded-t bg-white mb-0 px-6 py-6">
                        <div className="text-center flex justify-between">
                            <h6 className="text-blueGray-700 text-xl font-bold">Product Assignments</h6>
                            <Link to="/admin/inventory/productAssignmentForm">
                            <button
                                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Assignment
                            </button>
                            </Link>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingSpinner></LoadingSpinner>
                    ) : (<>
                        <div
                            className={
                                "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                                ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                            }
                        >

                            <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                                {/* Projects table */}
                                <ProductAssignmentListTable totalProductAssignments={totalProductsAssignment}></ProductAssignmentListTable>

                            </div>
                        </div>
                    </>)}
                </div>
            </main>

        </>
    );
}
